export const CPF_PATTERN = (field: string) => {
    return {
        value: /([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})/g,
        message: `${field} inválido`
    }
};

export const CNPJ_PATTERN = (field: string) => {
    return {
        value: /^\s*[A-Za-z0-9]{2}[.]?[A-Za-z0-9]{3}[.]?[A-Za-z0-9]{3}[/]?[A-Za-z0-9]{4}[-]?\d{2}\s*$/,
        message: `${field} inválido`
    }
};

export const normalizeCnpj = (value: string) => {
    return value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
};

export const NUMBER_PATTERN = (field: string) => {
    return {
        value: /\d/g,
        message: `${field} permitido apenas números`
    }
};


export const ALPHATEXT_PATTERN = (field: string) => {
    return {
        value: /^[A-Z\sa-záàâãéèêíïóôõöúçñ0-9]+$/i,
        message: `${field} permitido apenas letras`
    }
};



export const ALPHA_PATTERN = (field: string) => {
    return {
        value: /^[A-Za-z]+$/i,
        message: `${field} permitido apenas letras`
    }
};

export const CEP_PATTERN = (field: string) => {
    return {
        value: /\d{5}[\-]?\d{3}?/g,
        message: `${field} inválido XXXXX-XXX`
    }
};

export const TELEFONE_PATTERN = (field: string) => {
    return {
        value: /^[(]?[0-9]{2,3}[)]?[0-9]{4,5}[-]?[0-9]{4}$/g,
        message: `${field} inválido (XX)XXXXX-XXXX`
    }
};

export const EMAIL_PATTERN = (field: string) => {
    const normalizedField = field.trim().toLowerCase() === 'email'
        ? 'E-mail'
        : field.trim();

    return {
        value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/g,
        message: `${normalizedField} inválido`
    }
};

export const DOSE_PATTERN = (field: string) => {
    return {
        value: /^\d{1,2}\,\d{1,2}$/,
        message: `${field} inválido, valores aceito de 0,01 a 99,99`
    }
};
